<div
  class="phx-time-picker-input-box"
  [class.phx-input-focus]="dropdownOpen"
  [class.phx-input-disabled]="phxDisabled"
  (keydown)="onKeyDown($event)"
  (blur)="onBlur()"
  (focus)="onFocus()"
  tabindex="0"
>
  <i
    tabindex="0"
    [phxDropdownFor]="phxStart"
    [phxDisabled]="phxDisabled || phxPanelTimePicker"
    phxTrigger="click"
    (phxVisibleChange)="onDropDownMenuVisibilityChange($event)"
    *ngIf="!phxPanelTimePicker"
    phx-icon
    [phxIcon]="ClockIcon"
    [color]="dropdownOpen ? ClockActiveColor : 'currentColor'"
    class="phx-input-clock-icon"
  ></i>
  <div class="phx-time-input phx-web-type-body-medium" [class.phx-placeholder]="hours === null || !period || minutes === null || phxDisabled">
    <span [class.phx-time-picker-input-focused]="focusedField === 'hour'" (click)="setFocusedField('hour')">
      <span *ngIf="hours !== null">{{ hours | number: "2.0" }}</span>
      <span *ngIf="hours === null">00</span>
    </span>
    :
    <span [class.phx-time-picker-input-focused]="focusedField === 'minute'" (click)="setFocusedField('minute')">
      <span *ngIf="minutes !== null">{{ minutes | number: "2.0" }}</span>
      <span *ngIf="minutes === null">00</span>
    </span>
    <span *ngIf="!is24HourFormat" class="phx-period" [class.phx-time-picker-input-focused]="focusedField === 'ampm'" (click)="togglePeriod()">
      <span *ngIf="period">{{ period }}</span>
      <span *ngIf="!period">AM</span>
    </span>
  </div>
  <div *ngIf="phxPrefix">
    <ng-container *ngTemplateOutlet="phxPrefix"></ng-container>
  </div>
</div>
<phx-dropdown #phxStart>
  <phx-time-picker-panel
    [phxTimePickerFormat]="phxTimePickerFormat"
    [phxDisableBefore]="phxDisableBefore"
    [phxDisableAfter]="phxDisableAfter"
    [phxDisabledHours]="phxDisabledHours"
    [phxDisabledMinutes]="phxDisabledMinutes"
    [phxValue]="combinedValue"
    (phxValueChange)="dropDownValueChange($event)"
  ></phx-time-picker-panel>
  <div *ngIf="hours !== null || minutes !== null" (click)="writeValue(null)" class="phx-time-picker-panel-clear phx-web-type-body-medium">Clear</div>
</phx-dropdown>
